import { render, staticRenderFns } from "./projectListItem.vue?vue&type=template&id=27c3a766&scoped=true&"
import script from "./projectListItem.vue?vue&type=script&lang=js&"
export * from "./projectListItem.vue?vue&type=script&lang=js&"
import style0 from "./projectListItem.vue?vue&type=style&index=0&id=27c3a766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c3a766",
  null
  
)

export default component.exports